module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/superstar.186f31cd.png";